export default __webpack_public_path__ + "static/media/text category.edc1ef6e.png";